<div class="chip d-flex justify-content-between" [ngClass]="{ '-list': data.style === 'list', '-secondary': data.state === 'secondary', '-tertiary': data.state === 'tertiary' }">
    <mlp-ng-icon *ngIf="data.icon" [name]="data.icon" class="chip__icon text-left"></mlp-ng-icon>
    <span class="chip__label" [ngClass]="{'-sm': data.size === 'small', '-list': data.style === 'list'}">{{ data.name }}</span>
    <div class="chip__closebtn-wrapper ml-auto">
        <div class="chip__closebtn" *ngIf="data.removeButton !== false" [ngClass]="{'-list': data.style === 'list', 'pl-2': data.style !== 'list'}"
        (click)="removeChip()"><b>&times;</b></div>
    </div>
</div>